module.exports = __webpack_public_path__ + "static/media/img1.c4e60172.jpg";